/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetFixPromotionQueryVariables = Types.Exact<{
  version?: Types.InputMaybe<Types.ShopFixPromoVersion>;
}>;
export type GetFixPromotionQuery = {
  __typename?: "Query";
  shopContent?: {
    __typename?: "ShopContent";
    id: string;
    fixPromotion?: {
      __typename?: "ShopImagePromotion";
      headline: Array<string>;
      id: string;
      cta: {
        __typename?: "ShopContentCta";
        destinationPath: string;
        text: string;
      };
      image: {
        __typename?: "ShopContentImage";
        altText: string;
        baseUrl: string;
        mediaPath: string;
      };
      stickerLabel?: {
        __typename?: "ModeStickerLabel";
        label: string;
        theme: Types.ModeStickerLabelTheme;
      } | null;
      expandedContent: {
        __typename?: "ShopImagePromotionExpandedContent";
        description: string;
        title: string;
        cta: {
          __typename?: "ShopContentCta";
          destinationPath: string;
          text: string;
        };
        images: Array<{
          __typename?: "ShopContentImage";
          altText: string;
          baseUrl: string;
          mediaPath: string;
        }>;
      };
    } | null;
  } | null;
};
export const GetFixPromotionDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "getFixPromotion"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "version"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "ShopFixPromoVersion"
        }
      },
      defaultValue: {
        kind: "EnumValue",
        value: "DEFAULT"
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopContent"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "fixPromotion"
            },
            arguments: [{
              kind: "Argument",
              name: {
                kind: "Name",
                value: "version"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "version"
                }
              }
            }],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "cta"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "destinationPath"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "text"
                    }
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "image"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "altText"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "baseUrl"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "mediaPath"
                    }
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "headline"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "stickerLabel"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "label"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "theme"
                    }
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "expandedContent"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "cta"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "destinationPath"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "text"
                        }
                      }]
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "description"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "title"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "images"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "altText"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "baseUrl"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "mediaPath"
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;

/**
 * __useGetFixPromotionQuery__
 *
 * To run a query within a React component, call `useGetFixPromotionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFixPromotionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFixPromotionQuery({
 *   variables: {
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetFixPromotionQuery(baseOptions?: Apollo.QueryHookOptions<GetFixPromotionQuery, GetFixPromotionQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery<GetFixPromotionQuery, GetFixPromotionQueryVariables>(GetFixPromotionDocument, options);
}
export function useGetFixPromotionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFixPromotionQuery, GetFixPromotionQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery<GetFixPromotionQuery, GetFixPromotionQueryVariables>(GetFixPromotionDocument, options);
}
// @ts-ignore
export function useGetFixPromotionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFixPromotionQuery, GetFixPromotionQueryVariables>): Apollo.UseSuspenseQueryResult<GetFixPromotionQuery, GetFixPromotionQueryVariables>;
export function useGetFixPromotionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFixPromotionQuery, GetFixPromotionQueryVariables>): Apollo.UseSuspenseQueryResult<GetFixPromotionQuery | undefined, GetFixPromotionQueryVariables>;
export function useGetFixPromotionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFixPromotionQuery, GetFixPromotionQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery<GetFixPromotionQuery, GetFixPromotionQueryVariables>(GetFixPromotionDocument, options);
}
export type GetFixPromotionQueryHookResult = ReturnType<typeof useGetFixPromotionQuery>;
export type GetFixPromotionLazyQueryHookResult = ReturnType<typeof useGetFixPromotionLazyQuery>;
export type GetFixPromotionSuspenseQueryHookResult = ReturnType<typeof useGetFixPromotionSuspenseQuery>;
export type GetFixPromotionQueryResult = Apollo.QueryResult<GetFixPromotionQuery, GetFixPromotionQueryVariables>;